  /* CUSTOM PRODUCT IMAGE ZOOM - desktop hover-pan, mobile fullscreen pinch lightbox */
  (function () {
    var wrappers = document.querySelectorAll('.custom-product-image-zoom');
    var DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

    /* Build the shared lightbox once and append it to <body> */
    var lightbox = document.createElement('div');
    lightbox.className = 'custom-zoom-lightbox';
    /* HTML5 `inert` avoids the aria-hidden / retained-focus collisions */
    lightbox.setAttribute('inert', '');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Product image zoom');
    lightbox.innerHTML =
      '<button type="button" class="custom-zoom-lightbox__close" aria-label="Close zoom">&times;</button>' +
      '<button type="button" class="custom-zoom-lightbox__arrow custom-zoom-lightbox__arrow--prev" aria-label="Previous image" style="display: none;"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>' +
      '<button type="button" class="custom-zoom-lightbox__arrow custom-zoom-lightbox__arrow--next" aria-label="Next image" style="display: none;"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>' +
      '<div class="custom-zoom-lightbox__counter" style="display: none;"></div>' +
      '<div class="custom-zoom-lightbox__viewport">' +
        '<div class="custom-zoom-lightbox__track"></div>' +
      '</div>' +
      '<div class="zoom-hint" aria-hidden="true"><span class="zoom-hint__icon" aria-hidden="true">🤏 </span>Pinch to zoom</div>';
    document.body.appendChild(lightbox);

    var lbClose    = lightbox.querySelector('.custom-zoom-lightbox__close');
    var lbPrev     = lightbox.querySelector('.custom-zoom-lightbox__arrow--prev');
    var lbNext     = lightbox.querySelector('.custom-zoom-lightbox__arrow--next');
    var lbCounter  = lightbox.querySelector('.custom-zoom-lightbox__counter');
    var lbViewport = lightbox.querySelector('.custom-zoom-lightbox__viewport');
    var lbTrack    = lightbox.querySelector('.custom-zoom-lightbox__track');
    var zoomHint   = lightbox.querySelector('.zoom-hint');
    var hintTimer  = null;
    var lbCloseTimer = null;   /* 580ms exit guard until display:none is restored */
    var lbOpenRaf = null;      /* pending open frame so a rapid close can cancel it */

    /* Restores focus to the element that opened the lightbox */
    var currentTrigger = null;
    var currentMediaItems = [];
    var currentSlideIndex = 0;

    var REDUCED_MQ = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* Shared-element morph (sticky-video-pill mechanics): WAAPI raises the
       photo out of the tapped tile; the exit is a pure CSS shrink back. */
    var lbMorph = {
      openAnim: null,
      naturalRect: null,
      openedAt: 0,
      openIndex: 0,
      trigger: null,
      fadeEl: null,
      restoreTimer: null,
      openToken: 0
    };

    /* PINCH + PAN STATE - runs alongside the multi-image horizontal swipe */
    var pinch = {
      scale: 1,
      translate: { x: 0, y: 0 },
      startDist: 0,
      startMid: { x: 0, y: 0 },
      startScale: 1,
      startTrans: { x: 0, y: 0 },
      isPanning: false,
      lastSingle: { x: 0, y: 0 },
      maxScale: 4,
      minScale: 1
    };

    function getActiveImg() {
      var slides = lbTrack.querySelectorAll('.custom-zoom-lightbox__slide');
      var slide = slides[currentSlideIndex];
      return slide ? slide.querySelector('.custom-zoom-lightbox__img') : lbTrack.querySelector('.custom-zoom-lightbox__img');
    }

    /* First visible corner radius walking up from the tapped tile, so the
       rise starts with the same rounding the page shows. */
    function lbEffectiveRadius(el) {
      var node = el;
      for (var i = 0; i < 4 && node && node.nodeType === 1; i++) {
        var radius = window.getComputedStyle(node).borderRadius;
        if (radius && radius !== '0px') return radius;
        node = node.parentElement;
      }
      return '0px';
    }

    function lbRevealImg() {
      var img = getActiveImg();
      if (img) img.style.visibility = '';
    }

    function lbClearMorphStyles(img) {
      if (!img) return;
      img.style.removeProperty('--cz-morph-x');
      img.style.removeProperty('--cz-morph-y');
      img.style.removeProperty('--cz-morph-sx');
      img.style.removeProperty('--cz-morph-sy');
      img.style.removeProperty('--cz-morph-radius');
      img.style.removeProperty('--cz-morph-end-opacity');
      img.style.visibility = '';
      img.style.transition = '';
      img.style.transform = '';
      img.style.opacity = '';
    }

    function lbResetFadeEl() {
      if (!lbMorph.fadeEl) return;
      lbMorph.fadeEl.style.opacity = '';
      lbMorph.fadeEl.style.pointerEvents = '';
      lbMorph.fadeEl.style.transition = '';
      lbMorph.fadeEl = null;
    }

    function lbSourceVisibleInSlider(wrap, slider) {
      var r = wrap.getBoundingClientRect();
      var s = slider.getBoundingClientRect();
      var overlap = Math.min(r.right, s.right) - Math.max(r.left, s.left);
      return overlap > Math.min(r.width, s.width) * 0.5;
    }

    function startLbMorph(token) {
      var img = getActiveImg();
      var triggerEl = lbMorph.trigger;
      if (!img || !triggerEl) {
        lbRevealImg();
        return;
      }

      function begin() {
        if (token !== lbMorph.openToken || !lightbox.classList.contains('is-open')) return;

        /* Measure the settled photo with every transform masked */
        img.style.transition = 'none';
        img.style.transform = 'none';
        var target = img.getBoundingClientRect();
        img.style.transform = '';
        img.style.transition = '';

        var source = triggerEl.getBoundingClientRect();
        if (!target.width || !target.height || !source.width || !source.height) {
          img.style.visibility = '';
          return;
        }

        var dx = (source.left + source.width / 2) - (target.left + target.width / 2);
        var dy = (source.top + source.height / 2) - (target.top + target.height / 2);
        var sx = Math.max(0.08, source.width / target.width);
        var sy = Math.max(0.08, source.height / target.height);
        var endRadius = window.getComputedStyle(img).borderRadius || '0px';
        var startRadius = lbEffectiveRadius(triggerEl);

        lbMorph.naturalRect = {
          cx: target.left + target.width / 2,
          cy: target.top + target.height / 2,
          w: target.width,
          h: target.height
        };
        lbMorph.openedAt = Date.now();

        img.style.visibility = '';
        var riseAnim = img.animate([
          {
            transform: 'translate3d(' + dx + 'px, ' + dy + 'px, 0) scale(' + sx + ', ' + sy + ')',
            borderRadius: startRadius,
            opacity: 0.25
          },
          {
            transform: 'translate3d(0px, 0px, 0px) scale(1, 1)',
            borderRadius: endRadius,
            opacity: 1
          }
        ], {
          duration: 780,
          easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
          fill: 'forwards'
        });
        /* Hand the transform back to pinch/pan as soon as the rise lands:
           a forwards-filled animation would otherwise outrank inline styles */
        riseAnim.onfinish = function () {
          if (lbMorph.openAnim === riseAnim) {
            try { riseAnim.cancel(); } catch (e) {}
            lbMorph.openAnim = null;
          }
        };
        lbMorph.openAnim = riseAnim;

        /* Hand-off: the tapped tile fades out under the rising photo */
        lbMorph.fadeEl = triggerEl;
        triggerEl.style.transition = 'opacity 0.2s ease';
        triggerEl.style.opacity = '0';
        triggerEl.style.pointerEvents = 'none';
      }

      if (img.complete && img.naturalWidth > 0) {
        begin();
        return;
      }
      var done = false;
      function fin() {
        if (done) return;
        done = true;
        img.removeEventListener('load', fin);
        img.removeEventListener('error', fin);
        begin();
      }
      img.addEventListener('load', fin);
      img.addEventListener('error', fin);
      /* never hold the rise hostage to a stalled network */
      window.setTimeout(fin, 400);
    }

    function applyTransform(animate) {
      var activeImg = getActiveImg();
      if (!activeImg) return;
      if (animate) {
        activeImg.style.transition = 'transform 220ms ease-out';
      } else {
        activeImg.style.transition = '';
      }
      activeImg.style.transform =
        'translate(' + pinch.translate.x.toFixed(2) + 'px, ' +
                     pinch.translate.y.toFixed(2) + 'px) ' +
        'scale(' + pinch.scale.toFixed(3) + ')';

      if (pinch.scale > 1.05) {
        lbTrack.classList.add('is-zoomed');
        activeImg.classList.add('is-zoomed');
      } else {
        lbTrack.classList.remove('is-zoomed');
        activeImg.classList.remove('is-zoomed');
      }
    }

    function resetZoom(animate) {
      pinch.scale = 1;
      pinch.translate.x = 0;
      pinch.translate.y = 0;
      pinch.isPanning = false;
      applyTransform(!!animate);
      lbTrack.classList.remove('is-zoomed');
      var activeImg = getActiveImg();
      if (activeImg) activeImg.classList.remove('is-zoomed');
    }

    function clampPan() {
      var activeImg = getActiveImg();
      if (!activeImg || pinch.scale <= 1) {
        pinch.translate.x = 0;
        pinch.translate.y = 0;
        return;
      }
      var rect = lbViewport.getBoundingClientRect();
      var imgW = activeImg.offsetWidth  * pinch.scale;
      var imgH = activeImg.offsetHeight * pinch.scale;
      var maxX = Math.max(0, (imgW - rect.width)  / 2);
      var maxY = Math.max(0, (imgH - rect.height) / 2);
      pinch.translate.x = Math.max(-maxX, Math.min(maxX, pinch.translate.x));
      pinch.translate.y = Math.max(-maxY, Math.min(maxY, pinch.translate.y));
    }

    function updateLightboxUI() {
      var total = currentMediaItems.length;
      if (total > 1) {
        if (lbPrev) {
          lbPrev.style.display = 'flex';
          lbPrev.disabled = (currentSlideIndex === 0);
        }
        if (lbNext) {
          lbNext.style.display = 'flex';
          lbNext.disabled = (currentSlideIndex === total - 1);
        }
        if (lbCounter) {
          lbCounter.style.display = 'block';
          lbCounter.textContent = (currentSlideIndex + 1) + ' / ' + total;
        }
      } else {
        if (lbPrev) lbPrev.style.display = 'none';
        if (lbNext) lbNext.style.display = 'none';
        if (lbCounter) lbCounter.style.display = 'none';
      }
    }

    function goToSlide(idx, animate) {
      if (idx < 0) idx = 0;
      if (idx >= currentMediaItems.length) idx = currentMediaItems.length - 1;
      currentSlideIndex = idx;
      /* A swap changes the natural photo box: force a live re-measure on exit */
      lbMorph.naturalRect = null;
      lbMorph.openedAt = 0;
      resetZoom(false);

      var slides = lbTrack.querySelectorAll('.custom-zoom-lightbox__slide');
      var targetSlide = slides[idx];
      if (targetSlide) {
        var targetLeft = targetSlide.offsetLeft;
        if (animate) {
          lbTrack.scrollTo({ left: targetLeft, behavior: 'smooth' });
        } else {
          lbTrack.scrollLeft = targetLeft;
        }
      }
      updateLightboxUI();
    }

    var lbScrollTimer = null;
    lbTrack.addEventListener('scroll', function () {
      if (pinch.scale > 1.05) return;
      clearTimeout(lbScrollTimer);
      lbScrollTimer = setTimeout(function () {
        var width = lbTrack.clientWidth;
        if (width > 0) {
          var newIdx = Math.round(lbTrack.scrollLeft / width);
          if (newIdx !== currentSlideIndex && newIdx >= 0 && newIdx < currentMediaItems.length) {
            currentSlideIndex = newIdx;
            /* A swipe changes the natural photo box: re-measure on exit */
            lbMorph.naturalRect = null;
            lbMorph.openedAt = 0;
            resetZoom(false);
            updateLightboxUI();
          }
        }
      }, 35);
    }, { passive: true });

    if (lbPrev) {
      lbPrev.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentSlideIndex - 1, true);
      });
    }
    if (lbNext) {
      lbNext.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentSlideIndex + 1, true);
      });
    }

    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;

    function onPinchStart(e) {
      if (e.touches.length === 2) {
        var t0 = e.touches[0];
        var t1 = e.touches[1];
        pinch.startDist  = Math.hypot(t1.clientX - t0.clientX, t1.clientY - t0.clientY);
        pinch.startMid.x = (t0.clientX + t1.clientX) / 2;
        pinch.startMid.y = (t0.clientY + t1.clientY) / 2;
        pinch.startScale = pinch.scale;
        pinch.startTrans.x = pinch.translate.x;
        pinch.startTrans.y = pinch.translate.y;
        pinch.isPanning = false;
      } else if (e.touches.length === 1) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartTime = Date.now();
        if (pinch.scale > 1.05) {
          pinch.isPanning = true;
          pinch.lastSingle.x = e.touches[0].clientX;
          pinch.lastSingle.y = e.touches[0].clientY;
        } else {
          pinch.isPanning = false;
        }
      }
    }

    function onPinchMove(e) {
      if (e.touches.length === 2 && pinch.startDist > 0) {
        if (e.cancelable) e.preventDefault();
        var t0 = e.touches[0];
        var t1 = e.touches[1];
        var dist = Math.hypot(t1.clientX - t0.clientX, t1.clientY - t0.clientY);
        var midX = (t0.clientX + t1.clientX) / 2;
        var midY = (t0.clientY + t1.clientY) / 2;

        var factor = dist / pinch.startDist;
        var newScale = pinch.startScale * factor;
        if (newScale < pinch.minScale) newScale = pinch.minScale;
        if (newScale > pinch.maxScale) newScale = pinch.maxScale;

        var dx = midX - pinch.startMid.x;
        var dy = midY - pinch.startMid.y;

        pinch.scale = newScale;
        pinch.translate.x = pinch.startTrans.x + dx;
        pinch.translate.y = pinch.startTrans.y + dy;

        clampPan();
        applyTransform(false);
      } else if (e.touches.length === 1 && pinch.isPanning && pinch.scale > 1.05) {
        if (e.cancelable) e.preventDefault();
        var dx1 = e.touches[0].clientX - pinch.lastSingle.x;
        var dy1 = e.touches[0].clientY - pinch.lastSingle.y;
        pinch.translate.x += dx1;
        pinch.translate.y += dy1;
        pinch.lastSingle.x = e.touches[0].clientX;
        pinch.lastSingle.y = e.touches[0].clientY;
        clampPan();
        applyTransform(false);
      } else if (e.touches.length === 1 && pinch.scale <= 1.05) {
        var diffX = Math.abs(e.touches[0].clientX - touchStartX);
        var diffY = Math.abs(e.touches[0].clientY - touchStartY);
        if (diffY > diffX && e.cancelable) {
          e.preventDefault();
        }
      }
      // When single finger and unzoomed (scale <= 1.05), native scroll-snap handles horizontal swiping
    }

    function onPinchEnd(e) {
      pinch.isPanning = false;
      pinch.startDist = 0;

      if (e.touches.length === 0) {
        if (pinch.scale < 1.01) {
          resetZoom(true);
        } else {
          clampPan();
          applyTransform(false);
        }

        // Fast horizontal swipe fallback detection
        if (pinch.scale <= 1.05) {
          var touchEndX = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : touchStartX;
          var touchEndY = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientY : touchStartY;
          var diffX = touchEndX - touchStartX;
          var diffY = touchEndY - touchStartY;
          var elapsed = Date.now() - touchStartTime;
          if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY) && elapsed < 320) {
            if (diffX < 0 && currentSlideIndex < currentMediaItems.length - 1) {
              goToSlide(currentSlideIndex + 1, true);
            } else if (diffX > 0 && currentSlideIndex > 0) {
              goToSlide(currentSlideIndex - 1, true);
            }
          }
        }
      }
    }

    function showHint() {
      if (!zoomHint) return;
      zoomHint.classList.add('is-visible');
      clearTimeout(hintTimer);
      hintTimer = setTimeout(hideHint, 3000);
    }
    function hideHint() {
      if (!zoomHint) return;
      zoomHint.classList.remove('is-visible');
      clearTimeout(hintTimer);
    }

    lbTrack.addEventListener('touchstart', onPinchStart, { passive: false });
    lbTrack.addEventListener('touchmove',  onPinchMove,  { passive: false });
    lbTrack.addEventListener('touchend',   onPinchEnd,   { passive: false });
    lbTrack.addEventListener('touchcancel',onPinchEnd,   { passive: false });
    lbTrack.addEventListener('touchstart', hideHint,     { passive: true });

    /* Double-tap to toggle between 1× and 2× zoom */
    var lastTap = 0;
    lbTrack.addEventListener('touchend', function (e) {
      if (e.touches.length !== 0) return;
      var now = Date.now();
      if (now - lastTap < 300) {
        if (e.cancelable) e.preventDefault();
        if (pinch.scale > 1.05) {
          resetZoom(true);
        } else {
          pinch.scale = 2;
          clampPan();
          applyTransform(true);
        }
        lastTap = 0;
      } else {
        lastTap = now;
      }
    }, { passive: false });

    function getAllGalleryMedia() {
      var media = [];
      var gallerySlides = document.querySelectorAll('.product-gallery-slide');
      if (gallerySlides && gallerySlides.length > 0) {
        gallerySlides.forEach(function (slide, idx) {
          var wrap = slide.querySelector('.custom-product-image-zoom');
          var img = slide.querySelector('img');
          var hires = wrap ? (wrap.getAttribute('data-high-res-img') || (img ? (img.currentSrc || img.src) : '')) : (img ? (img.currentSrc || img.src) : '');
          var alt = img ? (img.alt || '') : '';
          if (hires) {
            media.push({
              src: hires,
              alt: alt,
              index: idx
            });
          }
        });
      }
      return media;
    }

    function buildLightboxSlides(items, activeIndex) {
      lbTrack.innerHTML = '';
      currentMediaItems = items || [];
      currentSlideIndex = activeIndex || 0;

      currentMediaItems.forEach(function (item, idx) {
        var slide = document.createElement('div');
        slide.className = 'custom-zoom-lightbox__slide';
        slide.setAttribute('data-index', idx);

        var img = document.createElement('img');
        img.className = 'custom-zoom-lightbox__img';
        img.src = item.src;
        img.alt = item.alt || '';
        img.setAttribute('draggable', 'false');
        img.loading = (Math.abs(idx - currentSlideIndex) <= 1) ? 'eager' : 'lazy';

        slide.appendChild(img);
        lbTrack.appendChild(slide);
      });

      updateLightboxUI();

      requestAnimationFrame(function () {
        goToSlide(currentSlideIndex, false);
      });
    }

    var lightboxSavedScrollY = 0;

    function openLightbox(src, alt, triggerEl, customMediaList, startIndexParam) {
      lightboxSavedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      currentTrigger = triggerEl || currentTrigger;

      var allMedia = [];
      var startIndex = 0;

      if (customMediaList && Array.isArray(customMediaList) && customMediaList.length > 0) {
        // Direct media array passed (e.g. from Complete the Shringar modal)
        allMedia = customMediaList;
        startIndex = (typeof startIndexParam === 'number' && startIndexParam >= 0) ? startIndexParam : 0;
      } else {
        var isShringar = triggerEl && triggerEl.closest('#shringar-details-modal');
        allMedia = isShringar ? [] : getAllGalleryMedia();

        if (triggerEl) {
          var parentSlide = triggerEl.closest('.product-gallery-slide');
          if (parentSlide) {
            var pIdx = parseInt(parentSlide.getAttribute('data-index'), 10);
            if (!isNaN(pIdx)) startIndex = pIdx;
          }
        }
      }

      if (allMedia && allMedia.length > 0) {
        if (startIndex === 0 && src) {
          for (var i = 0; i < allMedia.length; i++) {
            if (allMedia[i].src === src) {
              startIndex = i;
              break;
            }
          }
        }
        buildLightboxSlides(allMedia, startIndex);
      } else {
        buildLightboxSlides([{ src: src, alt: alt || '' }], 0);
      }

      resetZoom(false);

      /* Rapid reopen: cancel a close that is mid-flight */
      if (lbCloseTimer) {
        clearTimeout(lbCloseTimer);
        lbCloseTimer = null;
      }
      if (lbMorph.restoreTimer) {
        clearTimeout(lbMorph.restoreTimer);
        lbMorph.restoreTimer = null;
      }
      if (lbMorph.openAnim) {
        try { lbMorph.openAnim.cancel(); } catch (e) {}
        lbMorph.openAnim = null;
      }
      lbResetFadeEl();
      lbMorph.naturalRect = null;
      lbMorph.openedAt = 0;
      lbMorph.openIndex = currentSlideIndex;
      lbMorph.trigger = currentTrigger;
      lbMorph.openToken += 1;
      var morphToken = lbMorph.openToken;
      lightbox.classList.remove('is-closing');

      lightbox.removeAttribute('inert');
      lightbox.style.display = 'flex';  /* 1) enable display (CSS keeps display:none otherwise) */
      /* Park the track on the active slide before the morph target is measured */
      var openSlideEl = lbTrack.querySelectorAll('.custom-zoom-lightbox__slide')[currentSlideIndex];
      if (openSlideEl) lbTrack.scrollLeft = openSlideEl.offsetLeft;
      void lightbox.offsetWidth;        /* flush so the closed state is rendered first */
      document.documentElement.classList.add('custom-zoom-lightbox-open');
      document.body.classList.add('custom-zoom-lightbox-open');
      showHint();
      /* Modal history: Back closes the lightbox through this same close fn. */
      if (window.DDModalHistory) window.DDModalHistory.notifyOpen(lightbox, function () { closeLightbox(); });

      /* Keep the photo hidden until the rise can start so no full-size frame flashes */
      var canMorph = !REDUCED_MQ.matches && !!currentTrigger && typeof (getActiveImg() || {}).animate === 'function';
      if (canMorph) {
        var preImg = getActiveImg();
        if (preImg) preImg.style.visibility = 'hidden';
      } else {
        lbRevealImg();
      }

      /* 2) Next frame -> add the animation class so the transitions play,
         and lift the photo out of the tapped tile. */
      if (lbOpenRaf) cancelAnimationFrame(lbOpenRaf);
      lbOpenRaf = requestAnimationFrame(function () {
        lbOpenRaf = null;
        lightbox.classList.add('is-open');
        if (lightbox.classList.contains('is-open') && lbClose) {
          try {
            lbClose.focus({ preventScroll: true });
          } catch (e) {
            lbClose.focus();
          }
        }
        if (canMorph) startLbMorph(morphToken);
      });
    }
    window.openProductLightbox = openLightbox;
    window.closeProductLightbox = closeLightbox;

    function closeLightbox() {
      /* Modal history: leaving the stack happens the moment close commits. */
      if (window.DDModalHistory) window.DDModalHistory.notifyClose(lightbox);
      /* Closed within the same frame it opened: cancel the pending open frame */
      if (lbOpenRaf) {
        cancelAnimationFrame(lbOpenRaf);
        lbOpenRaf = null;
        lbMorph.openToken += 1;
        if (lbMorph.openAnim) {
          try { lbMorph.openAnim.cancel(); } catch (e) {}
          lbMorph.openAnim = null;
        }
        lbClearMorphStyles(getActiveImg());
        lbResetFadeEl();
        lightbox.classList.remove('is-open', 'is-closing');
        lightbox.style.display = '';
        lightbox.setAttribute('inert', '');
        lbTrack.innerHTML = '';
        document.documentElement.classList.remove('custom-zoom-lightbox-open');
        document.body.classList.remove('custom-zoom-lightbox-open');
        hideHint();
        currentTrigger = null;
        lbMorph.naturalRect = null;
        lbMorph.openedAt = 0;
        lbMorph.trigger = null;
        return;
      }
      if (lbCloseTimer) return;                                /* close already in flight */
      if (!lightbox.classList.contains('is-open')) return;

      var activeImg = getActiveImg();
      var morphTrigger = lbMorph.trigger;
      var sameIndex = (currentSlideIndex === lbMorph.openIndex);

      /* Stop the rise engine so the CSS exit owns the transform again */
      if (lbMorph.openAnim) {
        try { lbMorph.openAnim.cancel(); } catch (e) {}
        lbMorph.openAnim = null;
      }
      if (lbMorph.restoreTimer) {
        clearTimeout(lbMorph.restoreTimer);
        lbMorph.restoreTimer = null;
      }

      /* Reset pinch first (writes an inline identity), then hand the
         transform over to the CSS exit. */
      resetZoom(false);
      if (activeImg) {
        activeImg.style.transition = '';
        activeImg.style.transform = '';
      }

      /* Natural photo box: stored at open, re-measured live once the rise
         has settled (also resets after a mid-session swipe). */
      var natural = lbMorph.naturalRect;
      if (!natural || (Date.now() - (lbMorph.openedAt || 0)) > 850) {
        if (activeImg) {
          activeImg.style.transition = 'none';
          activeImg.style.transform = 'none';
          var live = activeImg.getBoundingClientRect();
          activeImg.style.transform = '';
          activeImg.style.transition = '';
          natural = (live.width && live.height)
            ? { cx: live.left + live.width / 2, cy: live.top + live.height / 2, w: live.width, h: live.height }
            : null;
        } else {
          natural = null;
        }
      }

      /* Pick the tile to return to. Modal triggers (Shringar /
         complete-the-set) stay in place. For the main gallery, return to
         the tapped tile only while its slide is still active; after a
         swipe the overlay simply fades out. */
      var sourceEl = null;
      if (morphTrigger && document.contains(morphTrigger)) {
        sourceEl = morphTrigger;
        var isMainGallery = morphTrigger.closest && morphTrigger.closest('[data-gallery-slider], .product-gallery');
        if (isMainGallery && !sameIndex) {
          sourceEl = null;
          var mainSliderForMorph = document.querySelector('[data-gallery-slider]');
          if (mainSliderForMorph) {
            var mainSlidesForMorph = mainSliderForMorph.querySelectorAll('.product-gallery-slide');
            for (var s = 0; s < mainSlidesForMorph.length; s++) {
              if (parseInt(mainSlidesForMorph[s].getAttribute('data-index'), 10) === currentSlideIndex) {
                var destWrap = mainSlidesForMorph[s].querySelector('.custom-product-image-zoom');
                if (destWrap && lbSourceVisibleInSlider(destWrap, mainSliderForMorph)) sourceEl = destWrap;
                break;
              }
            }
          }
        }
      }

      var sourceRect = sourceEl ? sourceEl.getBoundingClientRect() : null;
      var canMorph = !REDUCED_MQ.matches && sourceRect && sourceRect.width && sourceRect.height && natural && natural.w && natural.h;
      var endRadius = activeImg ? (window.getComputedStyle(activeImg).borderRadius || '0px') : '0px';

      if (activeImg) {
        if (canMorph) {
          activeImg.style.setProperty('--cz-morph-x', ((sourceRect.left + sourceRect.width / 2) - natural.cx) + 'px');
          activeImg.style.setProperty('--cz-morph-y', ((sourceRect.top + sourceRect.height / 2) - natural.cy) + 'px');
          activeImg.style.setProperty('--cz-morph-sx', Math.max(0.08, sourceRect.width / natural.w).toFixed(4));
          activeImg.style.setProperty('--cz-morph-sy', Math.max(0.08, sourceRect.height / natural.h).toFixed(4));
          activeImg.style.setProperty('--cz-morph-radius', lbEffectiveRadius(sourceEl));
          activeImg.style.setProperty('--cz-morph-end-opacity', '0.35');
        } else {
          /* Neutral fallback: glass fade only, never a stale trajectory */
          activeImg.style.setProperty('--cz-morph-x', '0px');
          activeImg.style.setProperty('--cz-morph-y', '0px');
          activeImg.style.setProperty('--cz-morph-sx', '1');
          activeImg.style.setProperty('--cz-morph-sy', '1');
          activeImg.style.setProperty('--cz-morph-radius', endRadius);
          activeImg.style.setProperty('--cz-morph-end-opacity', '0');
        }
      }

      /* 1) Play the exit transition */
      lightbox.classList.remove('is-open');
      lightbox.classList.add('is-closing');
      document.documentElement.classList.remove('custom-zoom-lightbox-open');
      document.body.classList.remove('custom-zoom-lightbox-open');
      hideHint();

      // If closed from Shringar modal, notify Shringar to sync its active slide
      if (currentTrigger && currentTrigger.closest('#shringar-details-modal')) {
        document.dispatchEvent(new CustomEvent('shringar:zoom-closed', { detail: { index: currentSlideIndex } }));
      }

      // Sync active slide index back to the main product page gallery slider only if opened from main gallery
      var isMainGalleryTrigger = currentTrigger && currentTrigger.closest && currentTrigger.closest('[data-gallery-slider], .product-gallery');
      if (isMainGalleryTrigger) {
        var mainSlider = document.querySelector('[data-gallery-slider]');
        if (mainSlider) {
          var mainSlides = mainSlider.querySelectorAll('.product-gallery-slide');
          if (mainSlides && mainSlides[currentSlideIndex]) {
            mainSlider.scrollTo({
              left: mainSlides[currentSlideIndex].offsetLeft - mainSlider.offsetLeft,
              behavior: 'smooth'
            });
          }
        }
      }

      if (lbClose && typeof lbClose.blur === 'function') {
        lbClose.blur();
      }
      var active = document.activeElement;
      if (active && lightbox.contains(active) && typeof active.blur === 'function') {
        active.blur();
      }

      if (currentTrigger && typeof currentTrigger.focus === 'function' && document.contains(currentTrigger)) {
        try {
          if (currentTrigger.getAttribute('tabindex') === null) {
            currentTrigger.setAttribute('tabindex', '-1');
          }
          currentTrigger.focus({ preventScroll: true });
        } catch (err) {}
      }

      if (document.activeElement && lightbox.contains(document.activeElement)) {
        if (document.body && typeof document.body.focus === 'function') {
          try {
            document.body.focus({ preventScroll: true });
          } catch (e) {
            document.body.focus();
          }
        }
      }
      currentTrigger = null;

      if (typeof lightboxSavedScrollY === 'number' && lightboxSavedScrollY > 0) {
        var origScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo({ top: lightboxSavedScrollY, left: 0, behavior: 'auto' });
        requestAnimationFrame(function () {
          document.documentElement.style.scrollBehavior = origScrollBehavior;
        });
      }

      lightbox.setAttribute('inert', '');

      /* 2) The tile reappears at 380ms, under the still-shrinking photo */
      if (lbMorph.fadeEl) {
        lbMorph.restoreTimer = setTimeout(function () {
          lbMorph.restoreTimer = null;
          if (lbMorph.fadeEl) {
            lbMorph.fadeEl.style.opacity = '';
            lbMorph.fadeEl.style.pointerEvents = '';
          }
        }, 380);
      }

      /* 3) After the 580ms exit animation: hide and tear down */
      lbCloseTimer = setTimeout(function () {
        lbCloseTimer = null;
        lightbox.classList.remove('is-closing');
        lightbox.style.display = '';
        lbTrack.innerHTML = '';
        lbClearMorphStyles(activeImg);
        lbResetFadeEl();
        lbMorph.naturalRect = null;
        lbMorph.openedAt = 0;
        lbMorph.trigger = null;
      }, 580);
    }

    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target === lbViewport || e.target.classList.contains('custom-zoom-lightbox__slide')) {
        if (pinch.scale <= 1.05) {
          closeLightbox();
        } else {
          resetZoom(true);
        }
      }
    });

    lightbox.addEventListener('wheel', function (e) {
      if (e.cancelable) e.preventDefault();
    }, { passive: false });

    lightbox.addEventListener('touchmove', function (e) {
      if (e.target === lightbox || e.target === lbViewport || !lbTrack.contains(e.target)) {
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('is-open')) return;
      if (
        e.key === ' ' || e.key === 'Spacebar' || e.key === 'PageUp' || e.key === 'PageDown' ||
        e.key === 'Home' || e.key === 'End' || e.key === 'ArrowUp' || e.key === 'ArrowDown'
      ) {
        e.preventDefault();
        return;
      }
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        if (pinch.scale <= 1.05) goToSlide(currentSlideIndex - 1, true);
      } else if (e.key === 'ArrowRight') {
        if (pinch.scale <= 1.05) goToSlide(currentSlideIndex + 1, true);
      }
    });

    lbTrack.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var clickedImg = e.target.closest('.custom-zoom-lightbox__img');
        if (!clickedImg) return;
        e.stopPropagation();
        if (pinch.scale > 1.05) {
          resetZoom(true);
        } else {
          pinch.scale = 2;
          clampPan();
          applyTransform(true);
        }
      }
    });

    /* Per-wrapper behaviour */
    if (wrappers && wrappers.length) {
      wrappers.forEach(function (wrapper) {
        var img = wrapper.querySelector('img');
        if (!img) return;

        // DESKTOP: hover-pan - transform-origin tracks the cursor
        wrapper.addEventListener('mouseenter', function () {
          if (!DESKTOP_MQ.matches) return;
          img.classList.add('is-zoomed');
        });

        wrapper.addEventListener('mousemove', function (e) {
          if (!DESKTOP_MQ.matches) return;
          var rect = wrapper.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          var x = ((e.clientX - rect.left) / rect.width)  * 100;
          var y = ((e.clientY - rect.top)  / rect.height) * 100;
          /* Clamp to keep the origin inside the image so it doesn't
             flip at the edges during fast mouse travel. */
          x = Math.max(0, Math.min(100, x));
          y = Math.max(0, Math.min(100, y));
          img.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
        });

        wrapper.addEventListener('mouseleave', function () {
          if (!DESKTOP_MQ.matches) return;
          img.classList.remove('is-zoomed');
          img.style.transformOrigin = '50% 50%';
        });

        // MOBILE: tap or keyboard opens the lightbox; the viewport is re-checked inside
        // the handler so a mid-session resize toggles the right behaviour.
        wrapper.addEventListener('click', function (e) {
          if (DESKTOP_MQ.matches) return;
          e.preventDefault();
          e.stopPropagation();
          var hires = wrapper.getAttribute('data-high-res-img') || img.currentSrc || img.src;
          /* Pass `wrapper` so the lightbox can restore focus here on close. */
          openLightbox(hires, img.alt, wrapper);
        });

        wrapper.addEventListener('keydown', function (e) {
          if (DESKTOP_MQ.matches) return;
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var hires = wrapper.getAttribute('data-high-res-img') || img.currentSrc || img.src;
            openLightbox(hires, img.alt, wrapper);
          }
        });
      });
    }
  })();

  /* PRODUCT MEDIA CAROUSEL - dots, arrows and swipe sync */
  (function () {
    function initProductGallery() {
      var sliders = document.querySelectorAll('[data-gallery-slider]');
      if (!sliders.length) return;

      sliders.forEach(function (slider) {
        if (slider.getAttribute('data-gallery-initialized') === 'true') {
          return;
        }
        slider.setAttribute('data-gallery-initialized', 'true');

        var mediaWrap = slider.closest('[data-pdp-media]') || slider.parentElement || document;
        var slides = slider.querySelectorAll('.product-gallery-slide');
        if (!slides.length) return;

        // Helper: scroll slider smoothly to slide index
        function scrollToIndex(idx) {
          if (idx < 0 || idx >= slides.length) return;
          var target = slides[idx];
          if (target) {
            var targetLeft = target.offsetLeft - slider.offsetLeft;
            slider.scrollTo({
              left: targetLeft,
              behavior: 'smooth'
            });
          }
        }

        // 1. PAGINATION DOTS
        var dotsContainer = mediaWrap.querySelector('[data-gallery-dots]') || mediaWrap.querySelector('.product-pagination-dots') || mediaWrap.querySelector('.product-gallery-dots');
        var dots = dotsContainer ? dotsContainer.querySelectorAll('.dot') : [];

        function setActiveDot(idx) {
          if (!dots || !dots.length) return;
          if (idx < 0) idx = 0;
          if (idx >= dots.length) idx = dots.length - 1;
          dots.forEach(function (dot, i) {
            if (!dot) return;
            var isActive = (i === idx);
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        }

        slider.scrollToIndex = scrollToIndex;
        slider.setActiveDot = setActiveDot;

        function handleVariantMediaChange(e) {
          var detail = e && e.detail;
          if (!detail) return;
          var mediaId = detail.mediaId;
          var imageSrc = detail.imageSrc;
          var targetIndex = -1;

          if (mediaId && slides.length > 0) {
            for (var i = 0; i < slides.length; i++) {
              if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
                targetIndex = i;
                break;
              }
            }
          }

          if (targetIndex === -1 && imageSrc && slides.length > 0) {
            var cleanTarget = imageSrc.split('?')[0].replace(/^https?:/, '').split('/').pop();
            for (var j = 0; j < slides.length; j++) {
              var slideImg = slides[j].querySelector('img');
              if (slideImg) {
                var s = (slideImg.currentSrc || slideImg.src || '').split('?')[0].replace(/^https?:/, '').split('/').pop();
                if (cleanTarget && s && (cleanTarget === s || cleanTarget.indexOf(s) !== -1 || s.indexOf(cleanTarget) !== -1)) {
                  targetIndex = j;
                  break;
                }
              }
            }
          }

          if (targetIndex >= 0) {
            scrollToIndex(targetIndex);
            setActiveDot(targetIndex);
          }
        }

        document.addEventListener('product:variant:change', handleVariantMediaChange);

        if (dots && dots.length > 0) {
          setActiveDot(0);

          dots.forEach(function (dot) {
            if (dot && typeof dot.addEventListener === 'function') {
              dot.addEventListener('click', function () {
                var idx = parseInt(dot.getAttribute('data-index'), 10);
                if (!isNaN(idx)) {
                  scrollToIndex(idx);
                }
              });
            }
          });

          // Mobile touch-swipe sync via debounced scroll listener
          var scrollTimer = null;
          slider.addEventListener('scroll', function () {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
              var width = slider.clientWidth;
              if (width > 0) {
                var activeIdx = Math.round(slider.scrollLeft / width);
                setActiveDot(activeIdx);
              }
            }, 25);
          }, { passive: true });

          // Fast snap sync via IntersectionObserver
          if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry && entry.isIntersecting && entry.target) {
                  var idx = parseInt(entry.target.getAttribute('data-index'), 10);
                  if (!isNaN(idx)) {
                    setActiveDot(idx);
                  }
                }
              });
            }, {
              root: slider,
              threshold: 0.5
            });

            slides.forEach(function (slide) {
              if (slide) observer.observe(slide);
            });
          }
        }

        // 2. NAVIGATION ARROWS
        var prevBtn = mediaWrap.querySelector('[data-slider-prev]');
        var nextBtn = mediaWrap.querySelector('[data-slider-next]');

        if (prevBtn && typeof prevBtn.addEventListener === 'function') {
          prevBtn.addEventListener('click', function (e) {
            e.preventDefault();
            slider.scrollBy({
              left: -slider.clientWidth,
              behavior: 'smooth'
            });
          });
        }

        if (nextBtn && typeof nextBtn.addEventListener === 'function') {
          nextBtn.addEventListener('click', function (e) {
            e.preventDefault();
            slider.scrollBy({
              left: slider.clientWidth,
              behavior: 'smooth'
            });
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductGallery);
    } else {
      initProductGallery();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-gallery-slider]')) {
        var s = e.target.querySelector('[data-gallery-slider]');
        if (s) s.removeAttribute('data-gallery-initialized');
        initProductGallery();
      }
    });
  })();

